import { StringTransform } from '@ember-data/serializer/transform'
export default StringTransform
